import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const TICK_MS = 15000;
const INACTIVO_MS = 5 * 60 * 1000;

const enviar = (ruta, duracion_seg) => {
  const token = localStorage.getItem('token');
  if (!token || !ruta) return;
  fetch('/api/actividad-usuarios/vista', {
    method: 'POST', keepalive: true,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ ruta, duracion_seg: Math.min(Math.round(duracion_seg), 21600) }),
  }).catch(() => {});
};

// Registra cada pantalla visitada y el tiempo de uso real (pestaña visible y con interacción reciente).
export const ActividadTracker = () => {
  const { pathname } = useLocation();
  const actual = useRef({ ruta: null, seg: 0 });
  const ultimaInteraccion = useRef(Date.now());

  useEffect(() => {
    const marcar = () => { ultimaInteraccion.current = Date.now(); };
    const eventos = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    eventos.forEach((e) => window.addEventListener(e, marcar, { passive: true }));
    const tick = setInterval(() => {
      if (document.visibilityState === 'visible' && Date.now() - ultimaInteraccion.current < INACTIVO_MS) {
        actual.current.seg += TICK_MS / 1000;
      }
    }, TICK_MS);
    const salir = () => {
      if (actual.current.ruta && actual.current.seg > 0) enviar(actual.current.ruta, actual.current.seg);
      actual.current = { ruta: actual.current.ruta, seg: 0, enviado: true };
    };
    const volver = () => {
      if (actual.current.enviado) actual.current = { ruta: actual.current.ruta, seg: 0 };
    };
    window.addEventListener('pagehide', salir);
    window.addEventListener('pageshow', volver);
    return () => {
      eventos.forEach((e) => window.removeEventListener(e, marcar));
      clearInterval(tick);
      window.removeEventListener('pagehide', salir);
      window.removeEventListener('pageshow', volver);
      if (actual.current.ruta && !actual.current.enviado && actual.current.seg > 0) enviar(actual.current.ruta, actual.current.seg);
    };
  }, []);

  useEffect(() => {
    const prev = actual.current;
    if (prev.ruta && prev.ruta !== pathname && !prev.enviado) enviar(prev.ruta, prev.seg);
    if (prev.ruta !== pathname) actual.current = { ruta: pathname, seg: 0 };
  }, [pathname]);

  return null;
};

export default ActividadTracker;
